<template>
  <ui-dialog
    :show="isOpen"
    persistent
    scrollable
    max-width="623"
    @input="close"
  >
    <template #default>
      <p class="description">
        {{ $t("message.facilityCreate.dialog.facilityImported.description") }}
      </p>
    </template>
    <template #actions>
      <div class="d-flex justify-center w-100">
        <ui-button color="primary" class="mr-2" outlined @click="close">
          {{ $t("message.common.close") }}
        </ui-button>
        <ui-button color="primary" class="ml-2" @click="goToFacilitiesList">
          {{ $t("message.facilityCreate.dialog.facilityImported.goToBtn") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "FacilityImportedDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    goToFacilitiesList() {
      this.$router.push({ name: "business-addresses-list" });
    }
  }
};
</script>

<style lang="scss" scoped>
.description {
  @include font-size(18px);
  width: 90%;
  margin: 0 auto $spacing * 1.5;
  color: $text;
  font-weight: 500;
  text-align: center;
  line-height: 22px;
}
</style>
